<div class="page-header">
  <h1 class="page-header-title">{{ title }}</h1>
  <p class="page-header-description" *ngIf="description">{{ description }}</p>
</div>
